import {
  DepartmentPayload,
  DepartmentResponse,
  DepartmentsResponse,
  Id,
  Options,
  Resource
} from 'services/api';

import Company from './Company.service';

export default class Department extends Company {
  private static instance: Department;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
    // this related to how typescript transpile this line in es5
    // e.g. var _this = _super.call(this) || this;
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Get a list of company departments
   * @param {Id} [company_id] (optional) company id
   */
  list(params?: Record<string, any>, company_id?: Id) {
    return this.getEntities<DepartmentsResponse>(
      Resource.Departments,
      params,
      company_id
    );
  }

  /**
   * Get a department by id
   * @param {Id} id department id
   * @param {Id} [company_id] (optional) company id
   */
  get(id: Id, company_id?: Id) {
    return this.getEntity<DepartmentResponse>(
      Resource.Department,
      id,
      company_id
    );
  }

  /**
   * Create a department
   * @param {DepartmentPayload} payload
   * @param {string} payload.name departmnet name
   * @param {Id} [company_id] (optional) company id
   */
  create(payload: DepartmentPayload, company_id?: Id) {
    return this.createEntity<DepartmentResponse, DepartmentPayload>(
      Resource.Department,
      payload,
      company_id
    );
  }

  /**
   * Delete a department by id
   * @param {Id} id department id
   * @param {Id} [company_id] (optional) company id
   */
  delete(id: Id, company_id?: Id) {
    return this.deleteEntity(Resource.Department, id, company_id);
  }

  /**
   * Update a department by id
   * @param {Id} id resource id
   * @param {DepartmentPayload} payload
   * @param {string} payload.name department name
   * @param {Id} [company_id] (optional) company id
   */
  update(id: Id, payload: DepartmentPayload, company_id?: Id) {
    return this.updateEntity<DepartmentPayload>(
      Resource.Department,
      id,
      payload,
      company_id
    );
  }
}
